import React from 'react';
import { Image, Space } from 'antd';
import styled from 'styled-components';
import ICWLogo from 'assets/img/icw-logo.png';

const Container = styled(Space)`
  width: 100%;
  justify-content: space-between;
  align-items: flex-end;
  p{
    margin-bottom: 0;
    color: var(--Text-Black-003, #AAA);
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.1px;
  }
  .poweredBy{
    color: var(--Text-Black-001, #000);
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
}
`;
const AppFooter = () => {
  return (
    <Container>
      <p>© 2023 International Compliance Workshop ®. All Rights Reserved.</p>
      <Space direction="vertical" size={0}>
        <span className="poweredBy">Powered by</span>
        <Image preview={false} width={100} src={ICWLogo} />
      </Space>
    </Container>
  );
};

export default AppFooter;
